const referrals = {
    popUpConfig: {
        default: {
            title: 'Invite players to upgrade to Power',
            subtitle: 'Earn $10 credit* when you refer a player who becomes a <a class="power">Power User.</a>',
            text: 'Your Unique Referral Invite Link',
            showPromoBalance: true,
        },
    },
};

export default referrals;
